import clsx from 'clsx';
import { TableContainer, TableContainerProps } from './TableContainer';
import { TableRowsContainer, TableRowsContainerProps } from './TableRowsContainer';
import { TableTitle, TableTitleProps } from './TableTitle';

export interface AmountTableProps
  extends TableTitleProps,
    TableRowsContainerProps<any>,
    Omit<TableContainerProps, 'children' | 'hide'> {
  hideOnEmpty?: boolean;
  tableTitleClassName?: string;
  tableRowsContainerClassName?: string;
}

export const AmountTable = ({
  title,
  children,
  className,
  isLoading,
  hideOnEmpty,
  customEmptyElement,
  tableTitleClassName,
  tableRowsContainerClassName,
}: AmountTableProps) => {
  const hide = hideOnEmpty && !isLoading && (!children || (Array.isArray(children) && children.length === 0));

  return (
    <TableContainer hide={hide} isLoading={isLoading} className={clsx(className, 'AmountTable')}>
      <TableTitle title={title} className={clsx(tableTitleClassName, 'AmountTable-TableTitle')} />
      <TableRowsContainer
        customEmptyElement={customEmptyElement}
        className={clsx(tableRowsContainerClassName, 'AmountTable-TableRowsContainer rounded-b-2xl')}
      >
        {children}
      </TableRowsContainer>
    </TableContainer>
  );
};
